import { GET_TOP_MARKET_ERROR, GET_TOP_MARKET_LIST, GET_TOP_MARKET_LIST_REQUEST, UPDATE_TOP_MARKET_DATA, REMOVE_TOP_MARKET_DATA } from "../../ActionTypes/ActionTypes.js";

const initialState = {
    topMarketListLoading: false,
    topMarketListData: null,
    topMarketListError: null,
    topMarketListStatus: null,
    isModified: false,
    isFirstLoad: true,
};

const topMarketListReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_TOP_MARKET_LIST_REQUEST:
            return { ...state, topMarketListLoading: true, topMarketListStatus: null, topMarketListData: null };
        case GET_TOP_MARKET_LIST:
            return {
                topMarketListLoading: false, topMarketListData: action.payload, topMarketListError: null, topMarketListStatus: action?.payload?.success,
                isFirstLoad: false,
            };

        case GET_TOP_MARKET_ERROR:
            return { topMarketListLoading: false, topMarketListData: null, topMarketListError: action?.payload, topMarketListStatus: action?.payload?.success, isFirstLoad: false, };
        case UPDATE_TOP_MARKET_DATA:
            return {
                ...state,
                topMarketListData: {
                    ...state.topMarketListData,
                    result: {
                        ...state.topMarketListData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_TOP_MARKET_DATA:
            return { ...state, topMarketListData: null, topMarketListError: null, isModified: false, topMarketListStatus: null, isFirstLoad: true, topMarketListLoading: false }
        default:
            return state;
    }
};

export default topMarketListReducer;